import React from 'react';
import {
  forgotPassword,
  getInvitedUsers,
  GetInvitedUsersResponseType,
  inviteUser,
  InviteUserRequestType,
  InviteUserResponseType,
  resetPassword,
  sendConfirmEmail,
  signIn,
  SignInRequestData,
  signUp,
  SignUpRequestData,
  updateUser,
  UpdateUserRequestType,
  verifyEmail
} from 'app/organizations-api';

export interface ErrorResult {
  code: string;
  message: string;
  description?: string | React.ReactElement;
}

export interface GetResponseType<Entity extends any> {
  loading: boolean;
  error: ErrorResult | null;
  httpCode?: number;
  data: Entity | null;
}

export interface TokenResponseType {
  token: string;
}

export interface CreatedEntityResponseType {
  code: number;
}

export interface Pagination {
  currentPage: number;
  pageSize: number;
}

export const DefaultResponse = {
  data: null,
  error: null,
  httpCode: undefined,
  loading: true
};

type OrganizationsApi = {
  signUp: (
    data: SignUpRequestData,
    reCaptchaToken: string
  ) => Promise<GetResponseType<TokenResponseType>>;
  signIn: (data: SignInRequestData) => Promise<GetResponseType<TokenResponseType>>;
  sendConfirmEmail: (token: string) => Promise<GetResponseType<any>>;
  verifyEmail: (token: string) => Promise<GetResponseType<TokenResponseType>>;
  forgotPassword: (
    email: string,
    reCaptchaToken: string
  ) => Promise<GetResponseType<CreatedEntityResponseType>>;
  resetPassword: (password: string, token: string) => Promise<GetResponseType<TokenResponseType>>;
  inviteUser: (payload: InviteUserRequestType) => Promise<GetResponseType<InviteUserResponseType>>;
  getInvitedUsers: (
    page?: number,
    pageSize?: number
  ) => Promise<GetResponseType<GetInvitedUsersResponseType>>;
  updateUser: (
    userId: string,
    payload: UpdateUserRequestType
  ) => Promise<GetResponseType<InviteUserResponseType>>;
};

export const organizationsApi: OrganizationsApi = {
  signUp,
  signIn,
  sendConfirmEmail,
  verifyEmail,
  forgotPassword,
  resetPassword,
  inviteUser,
  getInvitedUsers,
  updateUser
};
